
<div class="position-fixed w-100 header-wrapper">
  <app-accessibility-nav></app-accessibility-nav>
   <app-navbar></app-navbar>
</div>
<section class="main-content">
  <router-outlet></router-outlet>
</section>
@if(renderUniversityContent){
<app-footer></app-footer>
}